// extracted by mini-css-extract-plugin
export default {"buttoms":"Dashboard_buttoms__nrBVj","button":"Dashboard_button__9BJ8N","addToCart":"Dashboard_addToCart__qy5r6"};